// TODO: Better approach for utils and its file structuring
//       Alias in webpack for importing utils

const isDescendant = (parent, child) => {
  let node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const getRectCoordinates = (childRect, baseRect) => {
  const rightX = baseRect.x + baseRect.width; // most right x
  const leftX = baseRect.x; // most left x
  const topY = baseRect.y; // most top y
  const bottomY = baseRect.y + baseRect.height; // most bottom y

  const childRectWidthMid = childRect.width / 2;
  const childRectHeightMid = childRect.height / 2;

  const baseRectWidthMid = baseRect.width / 2;
  const baseRectHeightMid = baseRect.height / 2;

  const coordinates = {
    topLeft: {
      name: 'top-left',
      x: leftX,
      y: topY - childRect.height,
      nextPlacements: [
        'bottomLeft',
        'right',
        'left',
        'top',
        'bottom',
        'topRight',
        'rightTop',
        'rightBottom',
        'bottomRight',
        'leftBottom',
        'leftTop'
      ],
      base: 'top'
    },
    top: {
      name: 'top',
      x: leftX - (childRectWidthMid - baseRectWidthMid),
      y: topY - childRect.height,
      nextPlacements: [
        'bottom',
        'right',
        'left',
        'topLeft',
        'topRight',
        'rightTop',
        'rightBottom',
        'bottomRight',
        'bottomLeft',
        'leftBottom',
        'leftTop'
      ],
      base: 'top'
    },
    topRight: {
      name: 'top-right',
      x: leftX - (childRect.width - baseRect.width),
      y: topY - childRect.height,
      nextPlacements: [
        'bottomRight',
        'right',
        'left',
        'top',
        'bottom',
        'topLeft',
        'rightTop',
        'rightBottom',
        'bottomLeft',
        'leftBottom',
        'leftTop'
      ],
      base: 'top'
    },
    rightTop: {
      name: 'right-top',
      x: rightX,
      y: topY,
      nextPlacements: [
        'leftTop',
        'top',
        'bottom',
        'right',
        'left',
        'rightBottom',
        'bottomRight',
        'bottomLeft',
        'leftBottom',
        'topLeft',
        'topRight'
      ],
      base: 'right'
    },
    right: {
      name: 'right',
      x: rightX,
      y: topY + (baseRectHeightMid - childRectHeightMid),
      nextPlacements: [
        'left',
        'top',
        'bottom',
        'rightTop',
        'rightBottom',
        'bottomRight',
        'bottomLeft',
        'leftBottom',
        'leftTop',
        'topLeft',
        'topRight'
      ],
      base: 'right'
    },
    rightBottom: {
      name: 'right-bottom',
      x: rightX,
      y: bottomY - childRect.height,
      nextPlacements: [
        'leftBottom',
        'top',
        'bottom',
        'right',
        'left',
        'rightTop',
        'bottomRight',
        'bottomLeft',
        'leftTop',
        'topLeft',
        'topRight'
      ],
      base: 'right'
    },
    bottomRight: {
      name: 'bottom-right',
      x: rightX - childRect.width,
      y: bottomY,
      nextPlacements: [
        'topRight',
        'right',
        'left',
        'top',
        'bottom',
        'bottomLeft',
        'leftBottom',
        'leftTop',
        'topLeft',
        'rightTop',
        'rightBottom'
      ],
      base: 'bottom'
    },
    bottom: {
      name: 'bottom',
      x: leftX - (childRectWidthMid - baseRectWidthMid),
      y: bottomY,
      nextPlacements: [
        'top',
        'right',
        'left',
        'bottomRight',
        'bottomLeft',
        'leftBottom',
        'leftTop',
        'topLeft',
        'topRight',
        'rightTop',
        'rightBottom'
      ],
      base: 'bottom'
    },
    bottomLeft: {
      name: 'bottom-left',
      x: leftX,
      y: bottomY,
      nextPlacements: [
        'topLeft',
        'right',
        'left',
        'top',
        'bottom',
        'bottomRight',
        'leftBottom',
        'leftTop',
        'topRight',
        'rightTop',
        'rightBottom'
      ],
      base: 'bottom'
    },
    leftBottom: {
      name: 'left-bottom',
      x: leftX - childRect.width,
      y: bottomY - childRect.height,
      nextPlacements: [
        'rightBottom',
        'top',
        'bottom',
        'left',
        'right',
        'lefTop',
        'topLeft',
        'topRight',
        'rightTop',
        'bottomRight',
        'bottomLeft'
      ],
      base: 'left'
    },
    left: {
      name: 'left',
      x: leftX - childRect.width,
      y: topY - (childRectHeightMid - baseRectHeightMid),
      nextPlacements: [
        'right',
        'top',
        'bottom',
        'leftBottom',
        'leftTop',
        'topLeft',
        'topRight',
        'rightTop',
        'rightBottom',
        'bottomRight',
        'bottomLeft'
      ],
      base: 'left'
    },
    leftTop: {
      name: 'left-top',
      x: leftX - childRect.width,
      y: topY,
      nextPlacements: [
        'rightTop',
        'top',
        'bottom',
        'right',
        'left',
        'leftBottom',
        'topLeft',
        'topRight',
        'rightBottom',
        'bottomRight',
        'bottomLeft'
      ],
      base: 'left'
    }
  };

  return coordinates;
};

export { capitalize, getRectCoordinates, isDescendant };
